// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Incident } from './Incident';
import {
    IncidentFromJSON,
    IncidentFromJSONTyped,
    IncidentToJSON,
    IncidentToJSONTyped,
} from './Incident';
import type { IncidentQueryResponseMeta } from './IncidentQueryResponseMeta';
import {
    IncidentQueryResponseMetaFromJSON,
    IncidentQueryResponseMetaFromJSONTyped,
    IncidentQueryResponseMetaToJSON,
    IncidentQueryResponseMetaToJSONTyped,
} from './IncidentQueryResponseMeta';

/**
 * 
 * @export
 * @interface IncidentQueryResponse
 */
export interface IncidentQueryResponse {
    /**
     * 
     */
    data?: Array<Incident>;
    /**
     * 
     */
    meta?: IncidentQueryResponseMeta;
}

/**
 * Check if a given object implements the IncidentQueryResponse interface.
 */
export function instanceOfIncidentQueryResponse(value: object): value is IncidentQueryResponse {
    return true;
}

export function IncidentQueryResponseFromJSON(json: any): IncidentQueryResponse {
    return IncidentQueryResponseFromJSONTyped(json, false);
}

export function IncidentQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentQueryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(IncidentFromJSON)),
        'meta': json['meta'] == null ? undefined : IncidentQueryResponseMetaFromJSON(json['meta']),
    };
}

export function IncidentQueryResponseToJSON(json: any): IncidentQueryResponse {
    return IncidentQueryResponseToJSONTyped(json, false);
}

export function IncidentQueryResponseToJSONTyped(value?: IncidentQueryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(IncidentToJSON)),
        'meta': IncidentQueryResponseMetaToJSON(value['meta']),
    };
}

